module.exports = __webpack_public_path__ + "static/img/loadPageImg.d49c737f.png";